@if (form) {
  <form class="dialog-form position-relative">
    <!-- Loading Overlay -->
    <!-- <app-overlay-loading-spinner *ngIf="isLoadingActionItem"></app-overlay-loading-spinner> -->

    @if (form.length) {
    <div class="row">
      <app-form [formConfig]="form" [validationEmit]="validationEmit" [hasButton]="false"
        (onFilterSelectField)="onFilterSelect($event)" (onChange)="valueChanged($event)"
        [validationErrors]="validationErrors" (onSubmit)="submitForm($event)">
      </app-form>
    </div>
    }

    @if (dataObj.data?.visible) {
    <div class="dialog-footer d-flex justify-content-between">
      <button type="button" [disabled]="isLoadingActionItem" class="btn btn-outline-main" (click)="onClose()">
        {{"GENERAL.CANCEL" | translate}}
      </button>
      <button type="button" [disabled]="isLoadingActionItem" class="btn btn-solid-main" (click)="emitValidation()">
        @if (isLoadingActionItem) {
        <span class="spinner-border spinner-border-sm mr-1"></span>
        }
        {{ dataObj.data?.type=='revoke' ? ("GENERAL.REVOKE" | translate) : ("GENERAL.ASSIGN" | translate) }}
      </button>
    </div>
    }
  </form>
  }
